import React from 'react';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import { Block, Heading, Icon, Text } from '../../../../../../components';
import {
  BackButton,
  InteractiveButton,
  // Uploader,
  ToggleCard,
  FileUploader
} from '../../../../components';
import moneyIcon from '../../../../../../../assets/icons/icon-money.svg';
import lineIcon from '../../../../../../../assets/icons/icon-line.svg';
import calendarIcon from '../../../../../../../assets/icons/icon-calendar.svg';
import clockIcon from '../../../../../../../assets/icons/icon-clock-black.svg';
import LightBox from '../../../../../../components/LightBox';
import Processing from '@/presentation/components/Processing';
import Spinner from '../../../../../../components/Spinner';
import Step from './components/Step';
import ModalConfirmation from '../../../../components/Modal/Modal';
import RequestExist from '@/presentation/modules/procedures/components/Modals/RequestExists';
import IDHelpers from '../../../../../../../core/helpers/IDHelper';
import closeIcon from '../../../../../../../assets/icons/icon-close-red.svg';
import ConfirmationQuit from './components/ConfirmationQuit';
import {
  ActionableButton,
  WhiteContainer,
  ContainerProcedure
} from '../info/components';
import CascadeSelectList from './components/CascadeSelectList';
import constants from '../../../../../../../core/constants';
import TextHelper from '../../../../../../../core/helpers/TextHelper';
import PinProcedure from '../../../../components/PinProcedure/PinProcedure';

const WrapLinkMoreInfo = styled.div`
  a {
    color: #5b36f2;
    text-decoration: underline;
    font-weight: bold;
  }
  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
  }
`;

const WrapFileUploader = styled.div`
  .fileuploader > div > div {
    padding: 0px;
  }
  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
  }
`;

const ChangeCareerCampusModalityRegisterView = (props: any) => {
  const {
    procedureSelectedInfo,
    pin1Safe,
    pin2Safe,
    currentAcademicData,
    isLightBoxOpen,
    handleBackButton,
    contentLightBox,
    isLoading,
    onFilesError,
    onFilesReady,
    onFilesClean,
    handleGoToExists,
    handleModalConfirmationQuit,
    handleModalConfirmationCancel,
    ModalRequestExistShow,
    handleModalConfirmationClose,
    handleModalRequestExistClose,
    isQuit,
    handleCloseLightBox,
    showFileUploader,
    handleChangeModality,
    handleChangeCampus,
    handleChangeProgram,
    disabledSelectCampus,
    disabledSelectCareer,
    modalityList,
    campusList,
    programList,
    linkSafe,
    isLoadingCampus,
    isLoadingProgram,
    disabledRequestButton,
    handleProcessing
  } = props;
  return (
    <div data-testid="cmp-changecareercampusregisterview">
      <ContainerProcedure>
        <Block customized justifyContent="flex-start" margin="0px 0px 16px">
          <BackButton onClick={handleBackButton} />
        </Block>
        {!procedureSelectedInfo && <Spinner />}
        {procedureSelectedInfo && (
          <Block customized alignItems="flex-start" justifyContent="flex-start">
            <ToggleCard>
              {/* {toggleTitle} */}
              <Text
                color="#161D1F"
                fontSize="14px"
                lineHeight="20px"
                fontWeight="900"
              >
                {procedureSelectedInfo?.name}
              </Text>
              <Block
                customized
                flexDirection="row"
                alignItems="center"
                margin="0px 0px 12px 0px"
              >
                {isMobile ? (
                  <Block
                    customized
                    flexDirection="column"
                    alignItems="center"
                    margin="8px 0px 0px 0px"
                  >
                    <Block customized flexDirection="row">
                      <Icon
                        customized
                        maxWidth="16.9px"
                        height="15px"
                        margin="0px 4.67px 0px 0px"
                      >
                        <img src={moneyIcon} alt="other" />
                      </Icon>
                      <Text
                        color="#161D1F"
                        fontSize="14px"
                        lineHeight="20px"
                        fontWeight="400"
                      >
                        Costo:{' '}
                        <Text fontWeight="700">
                          S/. {procedureSelectedInfo?.amount}.00
                        </Text>
                      </Text>
                    </Block>
                    <Block customized flexDirection="row" margin="6px 0px 0px">
                      <Icon
                        customized
                        maxWidth="13.33px"
                        margin="0px 5.33px 0px 0px"
                      >
                        <img src={calendarIcon} alt="other" />
                      </Icon>
                      <Text
                        color="#161D1F"
                        fontSize="12px"
                        lineHeight="16px"
                        fontWeight="400"
                      >
                        {procedureSelectedInfo?.endDate || ''}
                      </Text>
                      <Icon
                        customized
                        maxWidth="1px"
                        height="13px"
                        margin="0px 0px 0px 16px"
                      >
                        <img src={lineIcon} alt="other" />
                      </Icon>
                      <Icon
                        customized
                        maxWidth="13.33px"
                        margin="0px 5.33px 0px 17.33px"
                      >
                        <img src={clockIcon} alt="other" />
                      </Icon>
                      <Text
                        color="#161D1F"
                        fontSize="12px"
                        lineHeight="16px"
                        fontWeight="400"
                      >
                        {procedureSelectedInfo?.duration || ''}
                      </Text>
                    </Block>
                  </Block>
                ) : (
                  <Block
                    customized
                    flexDirection="row"
                    alignItems="center"
                    margin="8px 0px 0px 0px"
                  >
                    <Icon
                      customized
                      maxWidth="16.9px"
                      height="15px"
                      margin="0px 4.67px 0px 0px"
                    >
                      <img src={moneyIcon} alt="other" />
                    </Icon>
                    <Text
                      color="#161D1F"
                      fontSize="14px"
                      lineHeight="20px"
                      fontWeight="400"
                    >
                      Costo:{' '}
                      <Text fontWeight="700">
                        S/. {procedureSelectedInfo?.amount}.00
                      </Text>
                    </Text>
                    <Icon
                      customized
                      maxWidth="1px"
                      height="13px"
                      margin="0px 0px 0px 16px"
                    >
                      <img src={lineIcon} alt="other" />
                    </Icon>
                    <Icon
                      customized
                      maxWidth="13.33px"
                      margin="0px 5.33px 0px 17.33px"
                    >
                      <img src={calendarIcon} alt="other" />
                    </Icon>
                    <Text
                      color="#161D1F"
                      fontSize="12px"
                      lineHeight="16px"
                      fontWeight="400"
                    >
                      {procedureSelectedInfo?.endDate || ''}
                    </Text>
                    <Icon
                      customized
                      maxWidth="1px"
                      height="13px"
                      margin="0px 0px 0px 16px"
                    >
                      <img src={lineIcon} alt="other" />
                    </Icon>
                    <Icon
                      customized
                      maxWidth="13.33px"
                      margin="0px 5.33px 0px 17.33px"
                    >
                      <img src={clockIcon} alt="other" />
                    </Icon>
                    <Text
                      color="#161D1F"
                      fontSize="12px"
                      lineHeight="16px"
                      fontWeight="400"
                    >
                      {procedureSelectedInfo?.duration || ''}
                    </Text>
                  </Block>
                )}
              </Block>
              {/* {toggleContent} */}
              <Block customized>
                <Block customized margin="0px 0px 16px 0px">
                  <WrapLinkMoreInfo>
                    <ul
                      style={{
                        listStyleType: 'disc',
                        display: 'block',
                        marginLeft: 16
                      }}
                    >
                      <li key={IDHelpers.generateID()}>{linkSafe}</li>
                    </ul>
                  </WrapLinkMoreInfo>
                </Block>
                <Heading
                  text="¿Qué requisitos necesito?"
                  level={3}
                  color="var(--text-text02)"
                  size={14}
                  lineHeight={20}
                  fontWeight="700"
                  className=""
                  align="flex-start"
                  width="auto"
                />
                <Block
                  customized
                  margin="12px 0px 0px 16px"
                  style={{ width: 'auto' }}
                >
                  {/* <ol style={{ listStyle: 'decimal' }}>
                    {procedureSelectedInfo?.requirements?.map((r: string) => (
                      <li key={IDHelpers.generateID()}>{r}</li>
                    ))}
                  </ol> */}
                  <ul
                    style={{
                      listStyleType: 'disc',
                      display: 'block'
                    }}
                  >
                    {procedureSelectedInfo?.requirements?.map((r: string) => (
                      <li key={IDHelpers.generateID()}>{r}</li>
                    ))}
                  </ul>
                </Block>

                {/* <Block
                  customized
                  maxWidth={isMobile ? '100%' : '744px'}
                  backgroundColor="#fff"
                  padding="16px"
                  borderRadius="8px"
                  margin="12px 0px 0px 0px"
                >
                  <Heading
                    text="Pasos a seguir"
                    level={3}
                    color="var(--text-text02)"
                    size={14}
                    lineHeight={20}
                    fontWeight="700"
                    className=""
                    align="flex-start"
                    width="100%"
                  />
                  <Block
                    customized
                    margin="12px 0px 0px 16px"
                    style={{ width: 'auto' }}
                  >
                    <ol style={{ listStyle: 'decimal' }}>
                      {procedureSelectedInfo?.stepsToFollow.map((r: string) => (
                        <li key={IDHelpers.generateID()}>{r}</li>
                      ))}
                    </ol>
                  </Block>
                </Block> */}
                <PinProcedure pinText={pin2Safe} />
                <PinProcedure pinText={pin1Safe} />
              </Block>
            </ToggleCard>
            {/* Progreso */}
            <Heading
              text="Progreso"
              level={2}
              color="var(--text-text02)"
              size={18}
              lineHeight={28}
              fontWeight="900"
              className=""
              align="flex-start"
            />
            {/* <TextTitle title="Progreso" /> */}
            <Block
              customized
              maxWidth={isMobile ? '100%' : '552px'}
              padding={isMobile ? '28px 0px 52px 8px' : '28px 0px 45px 16px'}
            >
              <Step
                name={procedureSelectedInfo.steps[0].name}
                order={procedureSelectedInfo.steps[0].order}
                isCurrent
              >
                <WhiteContainer>
                  <Text
                    color="#1A055D"
                    fontWeight="400"
                    fontSize="14px"
                    lineHeight="20px"
                  >
                    Actualmente estas estudiando en la modalidad{' '}
                    <Text fontWeight="700">
                      {currentAcademicData.modality.name.toUpperCase()}
                    </Text>{' '}
                    en el{' '}
                    <Text fontWeight="700">
                      {currentAcademicData.campus.name
                        .toUpperCase()
                        .includes('CAMPUS')
                        ? ''
                        : 'CAMPUS'}{' '}
                      {currentAcademicData.campus.name.toUpperCase()}
                    </Text>{' '}
                    en la carrera de{' '}
                    <Text fontWeight="700">
                      {currentAcademicData.program.name.toUpperCase()}
                    </Text>
                  </Text>
                  <Block customized margin="16px 0px 0px">
                    <Text fontWeight="400" fontSize="14px" lineHeight="20px">
                      Selecciona las opciones deseas cambiar y las que vas a
                      mantener:
                    </Text>
                  </Block>
                  <CascadeSelectList
                    optionsList={modalityList}
                    placeHolder="-modalidad-"
                    titleLabel="Cambio de modalidad:"
                    handleChangeSelect={handleChangeModality}
                  />
                  {showFileUploader && (
                    <WrapFileUploader>
                      <Block className="fileuploader" customized>
                        <FileUploader
                          title="Adjunta tu constancia de estudios técnicos o tu constancia de trabajo que verifique tus 3 años de experiencia laboral"
                          // titleWrap="initial"
                          allowedFormats=".jpeg,.jpg,.pdf"
                          displayFormats="JPG, PDF"
                          maxFileSize={5}
                          maxAllowFiles={4}
                          onFilesError={onFilesError}
                          onFilesClean={onFilesClean}
                          onFilesReady={onFilesReady}
                          // onSendFiles={() => {}}
                        />
                      </Block>
                    </WrapFileUploader>
                  )}
                  <CascadeSelectList
                    isDisabled={disabledSelectCampus}
                    optionsList={campusList?.map((campusItem: any) => ({
                      value: campusItem.value,
                      label: TextHelper.capitalize(campusItem.label)
                    }))}
                    placeHolder="-campus-"
                    titleLabel="Cambio de campus:"
                    handleChangeSelect={handleChangeCampus}
                    isLoading={isLoadingCampus}
                  />
                  {/* <InputText icon="search" placeholder="Buscar" /> */}
                  <CascadeSelectList
                    isDisabled={disabledSelectCareer}
                    optionsList={programList?.map((campusItem: any) => ({
                      value: campusItem.value,
                      label: TextHelper.capitalize(campusItem.label)
                    }))}
                    placeHolder="-carrera-"
                    titleLabel="Cambio de carrera:"
                    isFilterable
                    maxOptionsToFilter={15}
                    isLoading={isLoadingProgram}
                    handleChangeSelect={handleChangeProgram}
                  />
                  <ActionableButton
                    text="Solicitar"
                    marginTop={24}
                    onClick={handleProcessing}
                    enabled={disabledRequestButton}
                  />
                </WhiteContainer>
              </Step>
              <Step
                name={procedureSelectedInfo?.steps[1]?.name}
                order={procedureSelectedInfo?.steps[1]?.order}
                disabled
                isCurrent
              />
              <Step
                name={procedureSelectedInfo?.steps[2]?.name}
                order={procedureSelectedInfo?.steps[2]?.order}
                disabled
                isLast
              />
            </Block>
          </Block>
        )}
        <LightBox IsModalOpen={isLightBoxOpen} autoCloseLayer>
          <Block
            width="100%"
            customized
            flexDirection="row"
            justifyContent="flex-end"
            padding="8px 4px 0px"
          >
            <InteractiveButton
              bkgColorEnabled="none"
              bkgColorHover="#FED4D6"
              bkgColorFocus="#FDADB3"
              bkgColorPressed="#FDADB3"
              borderRadius="4px"
              customized
              onClick={handleCloseLightBox}
            >
              <Icon
                customized
                minWidth="40px"
                height="40px"
                alignItems="center"
                justifyContent="center"
              >
                {/* <Icon name="x" size={28} /> */}
                <img src={closeIcon} alt="other" />
              </Icon>
            </InteractiveButton>
          </Block>
          {contentLightBox}
        </LightBox>
        <Processing isOpen={isLoading} />
        <ModalConfirmation
          show={ModalRequestExistShow}
          // error && requestId
          handleClose={handleModalRequestExistClose}
        >
          <RequestExist handleClick={handleGoToExists} />
        </ModalConfirmation>
        <ModalConfirmation
          show={isQuit}
          handleClose={handleModalConfirmationClose}
        >
          <ConfirmationQuit
            handleQuit={handleModalConfirmationQuit}
            handleCancel={handleModalConfirmationCancel}
          />
        </ModalConfirmation>
      </ContainerProcedure>
    </div>
  );
};

export default ChangeCareerCampusModalityRegisterView;
